import { render } from "./EditOrAddForm.vue?vue&type=template&id=3994a55e&scoped=true&ts=true"
import script from "./EditOrAddForm.vue?vue&type=script&lang=ts"
export * from "./EditOrAddForm.vue?vue&type=script&lang=ts"

import "./EditOrAddForm.vue?vue&type=style&index=0&id=3994a55e&lang=less&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3994a55e"]])

export default __exports__